import { useCallback } from 'react'
import useDataEndpoint from './useDataEndpoint'
import api from '../api/chat'

export default function useRoster(connection) {
  const getRoster = useCallback(async () => {
    if (!connection) {
      return []
    }

    try {
      return api.roster.getRoster({ connection })
    } catch (err) {
      console.error('There was an error fetching the roster: ', err)
    }
    return []
  }, [connection])

  const results = useDataEndpoint(getRoster)
  if (!connection) return []
  return results
}
